import { HugeiconsIcon } from "@hugeicons/react";
import {
  SmartPhone01Icon,
  Video01Icon,
  Image01Icon,
  HeadphonesIcon,
  PencilEdit02Icon,
  Megaphone01Icon,
  AiChat02Icon,
  Recycle01Icon,
} from "@hugeicons/core-free-icons";
import { OnboardingTile } from "./OnboardingTile";

const CONTENT_GOALS = [
  {
    id: "short_form_video",
    label: "Short-form video",
    subtitle: "Reels, TikTok, Shorts",
    icon: SmartPhone01Icon,
  },
  {
    id: "long_form_video",
    label: "Long-form video",
    subtitle: "YouTube, tutorials",
    icon: Video01Icon,
  },
  {
    id: "images_visuals",
    label: "Images & visuals",
    subtitle: "Product shots, graphics",
    icon: Image01Icon,
  },
  {
    id: "audio_podcasts",
    label: "Audio & podcasts",
    subtitle: "Voiceovers, music, clips",
    icon: HeadphonesIcon,
  },
  {
    id: "written_content",
    label: "Written content",
    subtitle: "Blog posts, scripts, copy",
    icon: PencilEdit02Icon,
  },
  {
    id: "ad_creatives",
    label: "Ad creatives",
    subtitle: "Paid social, display ads",
    icon: Megaphone01Icon,
  },
  {
    id: "ai_agents",
    label: "AI agents",
    subtitle: "Research, automation",
    icon: AiChat02Icon,
  },
  {
    id: "repurpose_content",
    label: "Repurpose content",
    subtitle: "Transform existing content",
    icon: Recycle01Icon,
  },
] as const;

interface ContentGoalsStepProps {
  value: string[];
  onChange: (value: string[]) => void;
}

export function ContentGoalsStep({ value, onChange }: ContentGoalsStepProps) {
  function toggleGoal(goalId: string) {
    if (value.includes(goalId)) {
      onChange(value.filter((id) => id !== goalId));
    } else {
      onChange([...value, goalId]);
    }
  }

  return (
    <div>
      <h1 className="font-display text-3xl font-normal text-foreground">
        What would you like to create with Rayloop?
      </h1>
      <p className="mt-2 text-sm text-muted-foreground">
        Select all that apply
      </p>

      <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-4">
        {CONTENT_GOALS.map((goal) => (
          <OnboardingTile
            key={goal.id}
            icon={<HugeiconsIcon icon={goal.icon} strokeWidth={1.5} />}
            label={goal.label}
            subtitle={goal.subtitle}
            selected={value.includes(goal.id)}
            onClick={() => toggleGoal(goal.id)}
          />
        ))}
      </div>
    </div>
  );
}
